<template>
  <v-card class="core_card" variant="flate" style="height: 100%;overflow-y: auto !important;">
    <v-row>
      <v-col cols="12">
        <h2 class="card_title">Organisation</h2>
      </v-col>

      <v-col cols="12">
        <div class="d-flex ga-2 align-center">
          <h2 class="sub_title">Executive Management</h2>
          <span v-if="role < 6" @click="formDialog('Executive Management')" class="mdi mdi-plus-circle "
            style="font-size: 20px;color: #082FB1;cursor: pointer;"></span>
        </div>
      </v-col>

      <v-col cols="12">
        <v-row class="side-scroll">
          <template v-for="(item, index) in leads" :key="index">
            <v-col v-if="item.deleted === 0" cols="4">
              <v-card class="pa-3" variant="flat" style="border: 1px solid #D0D0D0;border-radius: 12px;">
                <div class="d-flex justify-space-between">
                  <p style="font-size: 12px;font-weight: 600;margin-bottom: 10px;">{{ item.designation[0] }}</p>
                  <div v-if="role < 6">
                    <v-menu location="bottom">
                      <template #activator="{ props }">
                        <v-btn v-bind="props" icon variant="text" class="cursor-pointer">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>

                      <v-list density="compact">
                        <v-list-item @click="editLocation(item, index,'Executive Management')">
                          <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteLocation3(item, index)">
                          <v-list-item-title>Delete</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </div>

                <div class="d-flex align-center ga-6 mb-3">
                  <div>
                    <img :src="require('/src/assets/crown.png')" alt="Logo" />
                  </div>
                  <div>
                    <h4 class="text-start" style="font-size: 14px; font-weight: 700;margin-bottom: 5px;">
                      {{ `${item.first_name} ${item.last_name}` }}
                    </h4>
                    <p style="font-size: 14px;font-weight: 400;">{{ item.email[0] }}</p>
                  </div>
                </div>

                <div class="mod">
                  <!-- {{`Last Modified :` }} -->
                   <v-tooltip :text="item.modified_name" location="top">
                    <template #activator="{ props }">
                      <span
                        v-bind="props"
                        class="ma-1 py-1 px-1 chip"
                      >
                        {{ `${getTrimmedText(item?.modified_name) ?? ''}  ${item?.modified ? moment(item.modified).format('DD-MM-YYYY') : ''}`}}
                      </span>
                    </template>
                  </v-tooltip>
                </div>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </v-col>

      <!-- Salesperson -->
      <v-col cols="12">
        <div class="d-flex ga-3 align-center">
          <img :src="require('/src/assets/process-arrow.png')" alt="Logo1" />
          <h2 class="sub_title">Salesperson</h2>
          <span v-if="role < 6" @click="formDialog('Salesperson')" class="mdi mdi-plus-circle "
            style="font-size: 20px;color: #082FB1;cursor: pointer;"></span>
        </div>
      </v-col>

      <v-col cols="12" class="pt-0">
        <table style="width: 100%;" class="core_tabel">
          <thead></thead>
          <tbody>
            <template v-for="(value, index) in salesPerson" :key="index">
              <tr v-if="value.deleted === 0">
                <td style="border-top-left-radius:4px ;border-bottom-left-radius:4px;">
                  <div class="d-flex align-center justify-center"
                    style="width: 32px;height: 32px;border-radius: 50%;background-color: #1542F5; color: #ffff;">
                    {{ `${value?.first_name?.charAt(0) || ""}${value?.last_name?.charAt(0) || ""}` }}
                  </div>
                </td>
                <td style="font-size: 14px;font-weight: 600;">{{ `${value?.first_name} ${value?.last_name}` }}</td>
                <td style="text-decoration: underline;font-size: 12px;font-weight: 400;">{{ typeof value?.email ==="string"? value?.email:  value?.email[0]}}</td>
                <td style="font-size: 14px;font-weight: 400;">{{ role < 6 ? value?.mobile ?? '' : '**********' }}</td>
                <td style="font-size: 14px;font-weight: 500;">
                  <div class="d-flex ga-2 align-center">
                    <!-- <div
                      :style="{ width: '14px', height: '14px', backgroundColor: value?.status === 'Active' ? '#0DB768' : '#FF3B30' }">
                    </div>{{ value?.status }} -->
                      <v-tooltip>
                        <template #activator="{ props }">
                          <span
                            v-bind="props"
                            class="radar-dot"
                            :class="(value.status == 1 || value.status == 'Active') ? 'active' : 'inactive'"
                          ></span>
                          <span class="ml-4">{{ value.status }}</span>
                        </template>
                      
                        {{ (value.status == 1 || value.status == 'Active') ? 'Active' : 'Inactive' }}
                      </v-tooltip>
                  </div>
                </td>
                <td class="mod">
                  <!-- {{`Last Modified :` }} -->
                  <v-tooltip :text="value.modified_name" location="top">
                    <template #activator="{ props }">
                      <span
                        v-bind="props"
                        class="ma-1 py-1 px-1 chip"
                      >
                        {{ `${getTrimmedText(value?.modified_name) ?? ''}   ${value?.modified ? moment(value.modified).format('DD-MM-YYYY') : ''}`}}
                      </span>
                    </template>
                  </v-tooltip>
                </td>
                <td style="border-top-right-radius:4px ;border-bottom-right-radius:4px">
                  <v-menu location="bottom" v-if="role < 6">
                    <template #activator="{ props }">
                      <v-btn v-bind="props" icon variant="text" class="cursor-pointer">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>

                    <v-list density="compact">
                      <v-list-item @click="editLocation(value, index, 'Salesperson')">
                        <v-list-item-title>Edit</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteLocation1(value, index)">
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </v-col>

      <v-col cols="12">
        <div class="d-flex ga-3 align-center">
          <img :src="require('/src/assets/process-associate.png')" alt="Logo2" />
          <h2 class="sub_title">Production Owners</h2>
          <span v-if="role < 6" @click="formDialog('Production Owners')" class="mdi mdi-plus-circle "
            style="font-size: 20px;color: #082FB1;cursor: pointer;"></span>
        </div>
      </v-col>

      <v-col cols="12" class="pt-0">
        <table style="width: 100%;" class="core_tabel">
          <thead></thead>
          <tbody>
            <template v-for="(value, index) in productionOwner" :key="index">
              <tr v-if="value.deleted === 0">
                <td style="border-top-left-radius:4px ;border-bottom-left-radius:4px">
                  <div class="d-flex align-center justify-center"
                    style="width: 32px;height: 32px;border-radius: 50%;background-color: #1542F5; color: #ffff;">
                    {{ `${value?.first_name?.charAt(0) || ""}${value?.last_name?.charAt(0) || ""}` }}
                  </div>
                </td>
                <td style="font-size: 14px;font-weight: 600;">{{ `${value?.first_name} ${value?.last_name}` }}</td>
                <td style="text-decoration: underline;font-size: 12px;font-weight: 400;">{{typeof value?.email ==="string"? value?.email:  value?.email[0]}}</td>
                <td style="font-size: 14px;font-weight: 400;">{{ role < 6 ? value?.mobile ?? '' : '**********'}}</td>
                <td style="font-size: 14px;font-weight: 500;">
                  <div class="d-flex ga-2 align-center">
                    <!-- <div
                      :style="{ width: '14px', height: '14px', backgroundColor:  === 'Active' ? '#0DB768' : '#FF3B30' }">
                    </div>{{ value?.status }} -->
                      <v-tooltip>
                        <template #activator="{ props }">
                          <span
                            v-bind="props"
                            class="radar-dot"
                            :class="(value.status == 1 || value.status == 'Active') ? 'active' : 'inactive'"
                          ></span>
                          <span class="ml-4">{{ value.status }}</span>
                        </template>
                      
                        {{ (value.status == 1 || value.status == 'Active') ? 'Active' : 'Inactive' }}
                      </v-tooltip>
                  </div>
                </td>
                <td class="mod">
                  <v-tooltip :text="value.modified_name" location="top">
                    <template #activator="{ props }">
                      <span
                        v-bind="props"
                        class="ma-1 py-1 px-1 chip"
                      >
                        {{ `${getTrimmedText(value?.modified_name) ?? ''}  ${value?.modified ? moment(value.modified).format('DD-MM-YYYY') : ''}`}}
                      </span>
                    </template>
                  </v-tooltip>
                </td>
                <td style="border-top-right-radius:4px ;border-bottom-right-radius:4px">
                  <v-menu location="bottom" v-if="role < 6">
                    <template #activator="{ props }">
                      <v-btn v-bind="props" icon variant="text" class="cursor-pointer">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>

                    <v-list density="compact">
                      <v-list-item @click="editLocation(value, index, 'Production Owners')">
                        <v-list-item-title>Edit</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteLocation2(value, index)">
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </v-col>
    </v-row>
  </v-card>

  <v-dialog v-if="leadsDialog" v-model="leadsDialog" width="800">
    <LeadsForm @close="close" @save="save" :viewType="viewType" :designation="designation" :index="index"
      @update-location="updateLocation" :editLocationData="editLocationData" />
  </v-dialog>
</template>

<script>

import LeadsForm from '../../CoreforceTeam/Leads-form.vue'
import moment from "moment";
import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
export default {
    components: {
        LeadsForm
    },
    data: () => ({
        leadsDialog: false,
        designation: null,
        organisationData: {},
        leads: [],
        salesPerson: [],
        productionOwner: [],
        viewType: null,
        editLocationData: {},
        index: null,
        user_id:null,
        user_name:null,
        role:null
    }),
    created() {
        this.getOrganisation();
        let user = localStorage.getItem('user_details')
        user = JSON.parse(user)
        this.user_id = user.id
        this.user_name = user.username
        this.role = user.roles.role_type
        console.log(this.user_id,"this.user_id!!")
    },
    methods: {
        moment,
        getTrimmedText(text) {
          return text && text.length <= 12 ? text : text && text.slice(0, 12) + ' ...';
        },
        async getOrganisation() {
            let $id = this.$route.query.id
            this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
            console.log(this.organisationData, 'dataaaaaaaaaaaa')
            this.leads = this.organisationData && this.organisationData.organisation && this.organisationData.organisation.executive_management ? this.organisationData.organisation.executive_management : []
            this.salesPerson = this.organisationData && this.organisationData.organisation && this.organisationData.organisation.sales_person ? this.organisationData.organisation.sales_person : []
            this.productionOwner = this.organisationData && this.organisationData.organisation && this.organisationData.organisation.product_owners ? this.organisationData.organisation.product_owners : []
        },
        close() {
            this.leadsDialog = false
            // this.getOrganisation()
        },
        editLocation(item, index, $data) {
            this.editLocationData = item;
            this.designation = $data
            this.leadsDialog = true;
            this.index = index;
            this.viewType = "edit"
        },
        save(item, designation) {
            console.log(item, "item!!!", designation)
            if (designation === 'Executive Management') {
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                item.id = this.leads.length + 1
                item.created = now
                item.modified = null
                item.created_by = this.user_id  
                item.modified_by = null
                item.active = 1
                item.deleted = 0
                item.deleted_by = null
                this.leads.push(item)
            } else if (designation === 'Salesperson') {
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                item.id = this.salesPerson.length + 1
                item.created = now
                item.modified = null
                item.created_by = this.user_id  
                item.modified_by = null
                item.active = 1
                item.deleted = 0
                item.deleted_by = null
                this.salesPerson.push(item)
            } else if (designation === 'Production Owners') {
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                item.id = this.productionOwner.length + 1
                item.created = now
                item.modified = null
                item.created_by = this.user_id  
                item.modified_by = null
                item.active = 1
                item.deleted = 0
                item.deleted_by = null
                this.productionOwner.push(item)
            }
            this.saveAllData()
            this.getOrganisation()
        },
        updateLocation(data, index, designation) {
            console.log(data,designation,"updateLocation");
            
            if (designation === 'Executive Management') {
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                data.modified = now
                data.modified_by = this.user_id,
                data.modified_name = this.user_name,
                this.leads[index] = data
            } else if (designation === 'Salesperson') {
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                data.modified = now
                data.modified_by = this.user_id,
                data.modified_name = this.user_name,
                this.salesPerson[index] = data
            } else if (designation === 'Production Owners') {
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                data.modified = now
                data.modified_by = this.user_id,
                data.modified_name = this.user_name,
                this.productionOwner[index] = data
            }
            this.saveAllData()
        },
        async saveAllData() {
            this.organisationData.organisation = {
                executive_management: this.leads,
                sales_person: this.salesPerson,
                product_owners: this.productionOwner
            }
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id: this.$route.query.id
            }
            await clientDetailsService.update($data)
            window.location.reload();
        },
        formDialog(designation) {
            this.designation = designation
            this.leadsDialog = true
            this.viewType = "add"
        },

        deleteLocation1(data, index) {
            // this.salesPerson.splice(index, 1);
            const now = moment().format('YYYY-MM-DD HH:mm:ss') 
            data.modified = now
            data.modified_by = this.user_id,
            data.active = 0
            data.deleted = 1
            data.deleted_by = this.user_id
            this.salesPerson[index] = data;
            this.saveAllData()
        },

        deleteLocation2(data, index) {
            // this.productionOwner.splice(index, 1);
            const now = moment().format('YYYY-MM-DD HH:mm:ss') 
            data.modified = now
            data.modified_by = this.user_id,
            data.active = 0
            data.deleted = 1
            data.deleted_by = this.user_id
            this.productionOwner[index] = data;
            this.saveAllData()
        },
         deleteLocation3(data, index) {
            // this.leads.splice(index, 1);
            const now = moment().format('YYYY-MM-DD HH:mm:ss') 
            data.modified = now
            data.modified_by = this.user_id,
            data.active = 0
            data.deleted = 1
            data.deleted_by = this.user_id
            this.leads[index] = data;
            console.log(data,"ddddrrrrr");
            this.saveAllData()
        },
    }
}
</script>
<style scoped>
.side-scroll{
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}
.modifydate{
  display: flex;
  justify-content: end;
}
.mod{
  font-size: 12px;
  font-weight: 500;
  text-align: end;
}
.chip{
  font-size: 12px;
  font-weight: 600;
  color: crimson;
}
.core_card {
    background-color: #FEFEFE;
    padding: 20px;
}

.card_title {
    font-size: 20px;
    font-weight: 600;
}

.sub_title {
    font-size: 14px;
    font-weight: 700;
}

.core_tabel {
    border-collapse: separate;
    border-spacing: 0 10px;
}

.core_tabel tbody tr {
    border-radius: 8px;
    overflow: hidden;
    display: table-row;
}

.core_tabel tbody tr td {
    padding: 12px 26px !important;
    background-color: #F2F2F2;
}
.radar-dot {
  width: 15px;
  height: 15px;
  left: 15px;
  top: 0px;
  border-radius: 50%;
  position: relative;
  display: inline-block;
}

.radar-dot.active {
  background-color: #22c55e;
}

.radar-dot.active::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background: rgba(34, 197, 94, 0.5);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: radarPulseGreen 0.5s infinite ease-out;
}

.radar-dot.inactive {
  background-color: crimson;
}

.radar-dot.inactive::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background: rgba(220, 20, 60, 0.5);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: radarPulseRed 2s infinite ease-out;
}

@keyframes radarPulseGreen {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.7;
  }
  100% {
    transform: translate(-50%, -50%) scale(4.2); 
    opacity: 0;
  }
}

@keyframes radarPulseRed {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.7;
  }
  100% {
    transform: translate(-50%, -50%) scale(3.6); 
    opacity: 0;
  }
}
</style>